import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import Dashboard from "@/pages/Dashboard";
import MemberDetail from "@/pages/MemberDetail";
import BusinessDetail from "@/pages/BusinessDetail";
import MyProfile from "@/pages/MyProfile";
import BusinessForm from "@/pages/BusinessForm";
import AdminDashboard from "@/pages/AdminDashboard";
import MapPage from "@/pages/MapPage";
import EventsList from "@/pages/EventsList";
import EventDetail from "@/pages/EventDetail";
import BlogsList from "@/pages/BlogsList";
import BlogDetail from "@/pages/BlogDetail";
import BlogForm from "@/pages/BlogForm";
import KecamatanPage from "@/pages/KecamatanPage";
import PengurusPage from "@/pages/PengurusPage";

function ProtectedRoute({ children, requireVerified = true, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center bg-bizma-cream text-bizma-subtext" data-testid="loading-screen">Memuat...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (requireVerified && !user.is_email_verified) return <Navigate to="/verify-email" replace />;
  if (adminOnly && user.role !== "admin" && user.role !== "pengurus") return <Navigate to="/app" replace />;
  return children;
}

const TITLES = {
  "/": "BIZMA Community — Grow Together",
  "/login": "Masuk — BIZMA", "/register": "Daftar — BIZMA",
  "/forgot-password": "Lupa Password — BIZMA", "/verify-email": "Verifikasi Email — BIZMA",
  "/app": "Direktori — BIZMA", "/app/me": "Profil — BIZMA", "/app/map": "Peta — BIZMA",
  "/app/events": "Event — BIZMA", "/app/blog": "Blog — BIZMA", "/app/pengurus": "Pengurus — BIZMA", "/admin": "Admin — BIZMA",
};

function AppRouter() {
  const location = useLocation();
  useEffect(() => {
    const p = location.pathname;
    let t = TITLES[p];
    if (!t) {
      if (p.startsWith("/app/members/")) t = "Profil Anggota — BIZMA";
      else if (p.startsWith("/app/businesses/")) t = "Bisnis — BIZMA";
      else if (p.startsWith("/app/events/")) t = "Event — BIZMA";
      else if (p.startsWith("/app/blog/")) t = "Blog — BIZMA";
      else if (p.startsWith("/app/kecamatan/")) t = "Grup Kecamatan — BIZMA";
      else t = "BIZMA Community — Grow Together";
    }
    document.title = t;
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/verify-email" element={<ProtectedRoute requireVerified={false}><VerifyEmail /></ProtectedRoute>} />
      <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/app/members/:id" element={<ProtectedRoute><MemberDetail /></ProtectedRoute>} />
      <Route path="/app/businesses/:id" element={<ProtectedRoute><BusinessDetail /></ProtectedRoute>} />
      <Route path="/app/me" element={<ProtectedRoute><MyProfile /></ProtectedRoute>} />
      <Route path="/app/businesses/new" element={<ProtectedRoute><BusinessForm /></ProtectedRoute>} />
      <Route path="/app/businesses/:id/edit" element={<ProtectedRoute><BusinessForm /></ProtectedRoute>} />
      <Route path="/app/map" element={<ProtectedRoute><MapPage /></ProtectedRoute>} />
      <Route path="/app/events" element={<ProtectedRoute><EventsList /></ProtectedRoute>} />
      <Route path="/app/events/:id" element={<ProtectedRoute><EventDetail /></ProtectedRoute>} />
      <Route path="/app/blog" element={<ProtectedRoute><BlogsList /></ProtectedRoute>} />
      <Route path="/app/blog/new" element={<ProtectedRoute><BlogForm /></ProtectedRoute>} />
      <Route path="/app/blog/:id" element={<ProtectedRoute><BlogDetail /></ProtectedRoute>} />
      <Route path="/app/blog/:id/edit" element={<ProtectedRoute><BlogForm /></ProtectedRoute>} />
      <Route path="/app/kecamatan/:nama" element={<ProtectedRoute><KecamatanPage /></ProtectedRoute>} />
      <Route path="/app/pengurus" element={<ProtectedRoute><PengurusPage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors position="top-center" />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}
export default App;
